import { useContext } from "react";
import { WorkspaceIdContext } from "../context/workspaceIdContext";

/**
 * Id of the tenant workspace, handed down by context from ViewWrapper (which
 * resolves it once with useTenantWorkspace and mounts the provider only once the
 * workspace is resolved: below it the value is ALREADY there on the first render).
 *
 * Deliberately with NO fallback to the platform hook: outside the provider it
 * returns undefined (and queries with `enabled: !!workspaceId` stay disabled)
 * instead of falling back to useCurrentWorkspace, which — besides its first
 * render at null (see useTenantWorkspace) — would return the workspace selected
 * in the shell, NOT the tenant the app must operate on.
 */
export const useWorkspaceId = (): string | undefined =>
    useContext(WorkspaceIdContext);
